export default __webpack_public_path__ + "static/media/brand2.cfaa5149.png";